import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import AuthenticatedRoute from "../../../middlewares/AuthenticatedRoute";
import { SOAReportProvider } from "../../../context/states/reports/SOAReportState";
import { AccountStatementProvider } from "../../../context/states/reports/accountStatementState";
import { InvoiceSummaryProvider } from "../../../context/states/reports/invoiceSummaryState";
import { InvoicePaymentProvider } from "../../../context/states/reports/invoicePaymentState";
import { BookingReportProvider } from "../../../context/states/reports/bookingReportState";
import { ProformaReportProvider } from "../../../context/states/reports/proformaReportState";
import { CreditNoteReportProvider } from "../../../context/states/reports/creditNoteReportState";
import { InterpreterInvoiceReportProvider } from "../../../context/states/reports/interpreterInvoiceState";
import { IPCreditNoteReportProvider } from "../../../context/states/reports/ipCreditNoteReportState";

// pages
import StatementOnAccount from "./StatementOnAccount";
import AccountStatement from "./AccountStatement";
import InvoiceSummary from "./InvoiceStatement";
import InvoicePayment from "./InvoicePayment";
import BookingsReport from "./Bookings";
import ProformaReport from "./proformaReport";
import CreditNoteReport from "./creditNoteReport";
import InterpreterInvoiceReport from "./interpreterInvoiceReport";
import RefundStatement from "./RefundStatement";
import IPCreditNoteReport from "./ipCreditNoteReport";

const Reports = () => {
  const { path } = useRouteMatch();

  return (
    <React.Fragment>
      <Switch>
        <AuthenticatedRoute
          permission="lil-sales-reports"
          exact
          path={`${path}/statementOnAccount`}
        >
          <SOAReportProvider>
            <StatementOnAccount />
          </SOAReportProvider>
        </AuthenticatedRoute>
        <AuthenticatedRoute
          permission="lil-internal-audit-report"
          exact
          path={`${path}/accountStatement`}
        >
          <AccountStatementProvider>
            <AccountStatement />
          </AccountStatementProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="refund-statement"
          exact
          path={`${path}/refundStatement`}
        >
          <AccountStatementProvider>
            <RefundStatement />
          </AccountStatementProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="lil-invoice-report"
          exact
          path={`${path}/invoiceSummary`}
        >
          <InvoiceSummaryProvider>
            <InvoiceSummary />
          </InvoiceSummaryProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="lil-paid-report"
          exact
          path={`${path}/invoicePayment`}
        >
          <InvoicePaymentProvider>
            <InvoicePayment />
          </InvoicePaymentProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="booking-report"
          exact
          path={`${path}/booking`}
        >
          <BookingReportProvider>
            <BookingsReport />
          </BookingReportProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="proforma-report"
          exact
          path={`${path}/proforma`}
        >
          <ProformaReportProvider>
            <ProformaReport />
          </ProformaReportProvider>
        </AuthenticatedRoute>
        <AuthenticatedRoute
          permission="credit-note-report"
          exact
          path={`${path}/creditNote`}
        >
          <CreditNoteReportProvider>
            <CreditNoteReport />
          </CreditNoteReportProvider>
        </AuthenticatedRoute>
        <AuthenticatedRoute
          permission="ip-invoice-report"
          exact
          path={`${path}/ipinvoice`}
        >
          <InterpreterInvoiceReportProvider>
            <InterpreterInvoiceReport />
          </InterpreterInvoiceReportProvider>
        </AuthenticatedRoute>

        <AuthenticatedRoute
          permission="ip-credit-note-report"
          exact
          path={`${path}/ipcreditnote`}
        >
          <IPCreditNoteReportProvider>
            <IPCreditNoteReport />
          </IPCreditNoteReportProvider>
        </AuthenticatedRoute>
      </Switch>
    </React.Fragment>
  );
};

export default Reports;
